(function() {
  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    if (url.includes('/cart/add')) {
      return originalFetch.apply(this, args).then(function(response) {
        if (!response.ok) return response;
        var clone = response.clone();
        clone.json().then(function(data) {
          if (typeof window._learnq === 'undefined') return;
          // The item(s) actually just added (single add returns an item, multi-add returns {items: [...]})
          var added = (data && data.items && data.items.length) ? data.items[data.items.length - 1] : data;

          originalFetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            if (!cart.items || cart.items.length === 0) return;
            var item = (added && added.product_id) ? added : cart.items[0];
            var cartItems = cart.items.map(function(i) {
              return {
                "Name": i.product_title,
                "ProductID": i.product_id,
                "SKU": i.sku,
                "ImageURL": i.image ? (i.image.indexOf('http') === 0 ? i.image : 'https:' + i.image) : '',
                "URL": window.location.origin + i.url,
                "Price": (i.price / 100).toFixed(2),
                "Quantity": i.quantity
              };
            });
            window._learnq.push(['track', 'Added to Cart', {
              "$value": (cart.total_price / 100).toFixed(2),
              "AddedItemProductName": item.product_title,
              "AddedItemProductID": item.product_id,
              "AddedItemSKU": item.sku,
              "AddedItemPrice": (item.price / 100).toFixed(2),
              "AddedItemQuantity": item.quantity,
              "AddedItemURL": window.location.origin + item.url,
              "AddedItemImageURL": item.image ? (item.image.indexOf('http') === 0 ? item.image : 'https:' + item.image) : '',
              "ItemNames": cartItems.map(function(i) { return i.Name; }),
              "CheckoutURL": window.location.origin + '/checkout',
              "Items": cartItems
            }]);
          });
        }).catch(function(){});
        return response;
      });
    }
    return originalFetch.apply(this, args);
  };
})();
